import { ENCRYPTED_KEY_BASE64_MAX_SIZE, ENCRYPTED_KEY_BASE64_MIN_SIZE, } from '../constants';
import { base64Validator } from './base64';
export const encryptedKeyByAesKeyValidator = base64Validator({
    requiredError: 'internal.key.required',
    minLength: {
        min: ENCRYPTED_KEY_BASE64_MIN_SIZE,
        error: 'internal.key.minLength',
    },
    maxLength: {
        max: ENCRYPTED_KEY_BASE64_MAX_SIZE,
        error: 'internal.key.maxLength',
    },
    invalidFormatError: 'internal.key.base64',
});
